module.exports = __webpack_public_path__ + "img/mpe2.5e13f5cc.png";